import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"

export const ToolsUses = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills" style={{marginTop:"3rem"}}>
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Tools and Environment</h2>
                        <p>Have exposure to the following devlopment environment <br></br> Always open to learn new dev environment and flow </p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src="https://cdn-icons-png.flaticon.com/512/906/906324.png" alt="vs studio" />
                                <h5>VS Code</h5>
                            </div>
                            <div className="item">
                                <img src="https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png" alt="skills" />
                                <h5>Git</h5>
                            </div>
                            <div className="item">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/IntelliJ_IDEA_Icon.svg/2048px-IntelliJ_IDEA_Icon.svg.png" alt="skills" />
                                <h5>IntelliJ</h5>
                            </div>
                            <div className="item">
                                <img src="https://miro.medium.com/max/512/1*9U1toerFxB8aiFRreLxEUQ.png" alt="sass css" />
                                <h5>Sass</h5>
                            </div>
                            <div className="item">
                                <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/1200px-Tailwind_CSS_Logo.svg.png" alt="tailwind" />
                                <h5>Tailwind CSS</h5>
                            </div>
                            <div className="item">
                                <img src="https://images.opencollective.com/chakra-ui-pro/61bd1dd/logo/256.png" alt="skills" />
                                <h5>Chakra UI</h5>
                            </div>
                            <div className="item">
                                <img src="https://symphony.com/wp-content/uploads/2020/12/sd-integrations-logo-jira.png" alt="skills" />
                                <h5>JIRA</h5>
                            </div>
                            <div className="item">
                                <img src="https://cdn-icons-png.flaticon.com/128/4494/4494740.png" alt="skills" />
                                <h5>Git</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
